import React from "react";
import * as Colors from "../../../utils/color_themes";
import { Container } from "react-bootstrap";
import { BaseWithNav } from "../../../components/RootLayout";
import "./style.scss";

const BaseLayout = ({
  header,
  children,
  bottomNavIndex = 0,
  show_menu = true,
  isCustom = false,
}) => {
  return (
    <BaseWithNav index={bottomNavIndex} show_menu={show_menu}>
      <Container fluid className="vh-100 zeropm base-wrapper">
        {isCustom ? (
          <div>{header}</div>
        ) : (
          <>
            <div
              className="base-wrapper-box"
              style={{ backgroundColor: Colors.primaryColor }}
            >
              <div className="base-wrapper-box-content">{header}</div>
            </div>
          </>
        )}
        <div>{children}</div>
      </Container>
    </BaseWithNav>
  );
};

export default BaseLayout;
